<template>
    <modal :title="$t(Atitle)" :appendToBody="appendToBody" :visible.sync="isShowDialog" width="600px">
        <div class="content">
            <div class="topContent">
                <el-checkbox v-model="checked" @change="changeFn" style="margin-right:10px"></el-checkbox>
                <span>{{ $t('integration.use_current_user_name') }}</span>
            </div>
            <el-input type="text" v-model="recordUser" v-if="!checked" maxlength="80" :placeholder="$t('integration.please_enter_a_name')"></el-input>
        </div>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="resolveFn">{{ $t('integration.confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { carrierRecordupdateBatch, carrierUpdate } from '@/api/modules/record.js';
export default {
    props: ['Atitle', 'isShow', 'choozeArray', 'optareStatus', 'rowPointId'],
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShow;
            },
            set: function(val) {
                this.$emit('update:isShow', val);
            }
        }
    },
    watch: {
        choozeArray(newVal) {
            this.tableArray = [...newVal];
        }
    },
    data() {
        return {
            appendToBody: true,
            checked: true,
            recordUser: null,
            tableArray: []
        };
    },
    methods: {
        resolveFn() {
            if ((!this.checked && this.recordUser === null) || this.recordUser === '') return this.$message.warning($t('integration.name_cannot_be_empty'));
            let httpUrl = '';
            let param;
            if (this.optareStatus === 'one') {
                httpUrl = carrierUpdate;
                param = { id: this.rowPointId, recordUser: this.recordUser };
            } else {
                httpUrl = carrierRecordupdateBatch;
                param = this.tableArray.map(item => {
                    return {
                        id: item.id,
                        recordUser: this.recordUser
                    };
                });
            }
            httpUrl(param).then(async ({ state }) => {
                await this.$resultHandle(state);
                this.isShowDialog = false;
                this.$parent.getListFn();
            });
        },
        changeFn(bool) {
            if (bool) {
                this.recordUser = null;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    margin: 20px 180px;
    .topContent {
        margin-bottom: 15px;
    }
}
</style>
